import { type Color } from '@mui/material'

// reason: these are the color tokens so they are hardcoded
/* eslint-disable @dhl/mui/no-hardcoded-colors */
export const grey = {
  100: '#FFFEFE',
  200: '#F2F2F2',
  250: '#F0F0F0',
  300: '#E8E8E8',
  400: '#D0D0D0',
  450: '#949494',
  500: '#B2B2B2',
  600: '#8C8C8C',
  700: '#424242',
  800: '#1C1C1E',
  900: '#030303',
  // TODO: these definitions are in MUI but not with ours, see where used and defined them correctly
  50: '#B2B2B2',
  A100: '#B2B2B2',
  A200: '#B2B2B2',
  A400: '#B2B2B2',
  A700: '#B2B2B2',
} satisfies Partial<Color>
